<template>
  <div>
    <div
      v-if="label"
      class="date-range-picker__label"
    >
      <label>{{ label }}</label>
    </div>
    <DateRangeInput
      v-if="!hideInput"
      ref="rangeinput"
      class="date-range-picker__text"
      :class="{
        'date-range-picker__text_small': small,
        'date-range-picker__text_disabled': disabled
      }"
      :disabled="disabled"
      :range="{startDate, endDate}"
      :small="small"
      :min-date="minDate"
      :max-date="maxDate"
      :range-key-mask="rangeKeyMask"
      @input="$emit('input', $event)"
      @dateSubmitted="$emit('dateSubmitted')"
    />
    <MIcon
      v-if="hideInput"
      :icon="calendarIcon"
      class="date-range-picker__calendar-icon"
    />
  </div>
</template>

<script>
  import DateRangeInput from 'components/Inputs/Dates/DateRangePicker/DateRangeInput';
  import MIcon from 'components/Design/MIcon.vue';

  import calendarIcon from 'assets/icons/calendar.svg';

  export default {
    name: 'DateRangeField',
    components: {DateRangeInput, MIcon},
    props: {
      label: {
        type: String,
        default: null
      },
      minDate: {
        type: Date,
        default: null
      },
      maxDate: {
        type: Date,
        default: null
      },
      startDate: {
        type: Date,
        default: null
      },
      endDate: {
        type: Date,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      hideInput: {
        type: Boolean,
        default: false
      },
      dateDelimiter: {
        type: String,
        default: '.'
      },
      rangeKeyMask: {
        type: String,
        default: null
      },
      small: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        calendarIcon
      };
    }
  };
</script>

<style>
  .date-range-picker__label label {
    font-family: var(--main-font-family);
    font-size: var(--main-font-size);
    font-weight: var(--medium-font-weight);

    color: var(--text-color);
    line-height: var(--main-line-height);

    white-space: nowrap;

    display: inline-block;

    padding: 0;

    margin-bottom: 8px;

    user-select: none;
  }

  .date-range-picker__text input:read-only {
    cursor: not-allowed;
    background-color: var(--background-color);
  }

  .date-range-picker__text.small {
    height: 28px;

    padding-top: 1px;
    padding-bottom: 1px;
  }

  .date-range-picker__text {
    overflow: hidden;

    cursor: pointer;

    display: flex;

    align-items: center;

    box-sizing: border-box;
    width: 182px;
    height: 32px;

    background-color: var(--background-color);

    border: solid 1px;

    border-radius: 6px;

    border-color: var(--border-color);

    transition: 250ms ease-in-out;
  }

  .date-range-picker__text_disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .date-range-picker__text_small {
    height: 28px;
  }

  .date-range-picker__text.disabled,
  .date-range-picker__text.disabled input {
    color: var(--gray-text-color);

    cursor: not-allowed;

    background-color: var(--gray-table-color);

    border: 1px solid var(--gray-table-color);
  }

  .date-range-picker__text.disabled input {
    width: 55px;
  }
</style>
